<template>
  <div class="alipay-container">
    <!-- 面包屑 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-goods"></i> 产品列表
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-card class="alipay-card" shadow="never">
      <!-- 标签页 -->
      <el-tabs v-model="activeName" @tab-click="tabClick" size="small" style="margin-bottom:15px">
        <el-tab-pane label="全部商品" name="first" />
        <el-tab-pane label="未上架" name="second" />
        <el-tab-pane label="已上架" name="third" />
        <el-tab-pane label="已下架" name="fourth" />
        <el-tab-pane label="已删除" name="fiveth" />
      </el-tabs>

      <!-- 搜索筛选 -->
      <div class="search-bar">
        <el-form :inline="true" :model="searchForm" size="mini">
          <el-form-item label="产品名称">
            <el-input v-model="searchForm.name" clearable placeholder="名称" style="width:140px"></el-input>
          </el-form-item>
          <el-form-item label="商品状态">
            <el-select v-model="searchForm.is_on_sale" clearable style="width:120px">
              <el-option v-for="item in saleList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="品牌">
            <el-input v-model="searchForm.brand_name" clearable placeholder="品牌" style="width:120px"></el-input>
          </el-form-item>
          <el-form-item label="商品编码">
            <el-input v-model="searchForm.goods_sn" clearable placeholder="编码" style="width:120px"></el-input>
          </el-form-item>
          <el-form-item label="审核状态">
            <el-select v-model="searchForm.is_auth" clearable style="width:120px">
              <el-option v-for="item in authList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="searchSubmit">搜索</el-button>
            <el-button type="success" size="mini" @click="addData">新增</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 统计卡片 -->
      <div class="stat-cards">
        <div class="stat-card">
          <div class="stat-icon total"><i class="el-icon-goods"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ total }}</div>
            <div class="stat-label">产品总数</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon detect"><i class="el-icon-bank"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ onSaleCount }}</div>
            <div class="stat-label">上架中</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon recommend"><i class="el-icon-star-on"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ recommendCount }}</div>
            <div class="stat-label">推荐商品</div>
          </div>
        </div>
      </div>

      <!-- 操作按钮 + Excel导入 -->
      <div class="btn-group">
        <el-button size="mini" type="success" icon="el-icon-top" @click="changeSale(1)">批量上架</el-button>
        <el-button size="mini" type="danger" icon="el-icon-bottom" @click="changeSale(2)">批量下架</el-button>
        <el-button size="mini" type="info" icon="el-icon-download" @click="goExcel">导出</el-button>

        <!-- Excel 批量更新价格 -->
       <input
  ref="excelInput"
  type="file"
  accept=".xlsx,.xls"
  style="display:none"
  @change="handleRealExcelChange"
>
<el-button 
  size="mini" 
  type="warning" 
  icon="el-icon-upload"
  @click="$refs.excelInput.click()"
>
  Excel批量更新价格
</el-button>
      </div>

      <!-- 表格 -->
      <div class="table-wrapper">
        <el-table
          ref="multipleTable"
          :data="tableLoadData"
          stripe
          border
          size="small"
          v-loading="loading"
          :header-cell-style="headerCellStyle"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="45" />
          <el-table-column :index="indexMethod" label="序号" width="50" align="center" />
          <el-table-column label="产品名称" prop="goods_name" min-width="160" show-overflow-tooltip />
          <el-table-column label="图片" width="60" align="center">
            <template slot-scope="scope">
              <el-image style="width:30px;height:30px" :src="scope.row.goods_img" fit="cover" />
            </template>
          </el-table-column>
          <el-table-column label="售价" prop="shop_price" width="70" align="center" />
          <el-table-column label="市场价" prop="market_price" width="70" align="center" />
          <el-table-column label="代发价" prop="cost_price" width="75" align="center" />
          <el-table-column label="品牌" width="80" align="center">
            <template slot-scope="scope">{{ scope.row.brand?.name || '-' }}</template>
          </el-table-column>
          <el-table-column label="状态" width="70" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" :type="scope.row.is_on_sale===1?'success':'info'">{{ scope.row.is_on_sale | isSale }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="handleClick(scope.row)">编辑</el-button>
              <el-button type="text" size="mini" @click="relationCar(scope.row)">关联</el-button>
              <el-button type="text" size="mini" class="delete-btn" @click="del(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 空状态 -->
      <div v-if="tableLoadData.length===0 && !loading" class="empty-state">
        <i class="el-icon-goods"></i>
        <p>暂无产品数据</p>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper" v-if="total>0">
        <el-pagination background size="small"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10,20,30,100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </el-card>

    <!-- 抽屉 -->
    <el-drawer size="40%" title="车辆列表" :visible.sync="drawerCar" class="alipay-drawer">
      <div class="drawer-content">
        <el-table :data="carList" stripe border size="small">
          <el-table-column label="序号" width="50" align="center">
            <template #default="scope">{{ (pageNum1-1)*pageSize1 + scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column label="图片" width="70" align="center">
            <template slot-scope="scope">
              <el-image style="width:35px;height:35px" :src="scope.row.file_url" fit="cover" />
            </template>
          </el-table-column>
          <el-table-column label="车型" min-width="140" />
          <el-table-column label="孔距" prop="pitch.name" width="70" />
        </el-table>
        <div class="pagination-wrapper" style="margin-top:15px">
          <el-pagination background size="small"
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
            :current-page="pageNum1"
            :page-size="pageSize1"
            :total="total1"
          />
        </div>
      </div>
    </el-drawer>

    <!-- 导入进度弹窗 -->
    <el-dialog 
  :visible.sync="importLoading" 
  width="460px" 
  center 
  :show-close="false" 
  :close-on-click-modal="false"
>
  <div style="text-align:center;padding:20px 0">
    <el-progress :percentage="importProgress" status="success" />
    <div style="margin-top:15px;font-size:14px">{{ importText }}</div>
    <div style="margin-top:10px;color:#666">成功：{{ successCount }} 条</div>
    <div style="color:#fa6b6b">失败：{{ failCount }} 条</div>
  </div>
</el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: "simpleGoodsList",
  data() {
    return {
      loading: false,
      importLoading: false,
      importProgress: 0,
      importText: '',
      successCount: 0,
      failCount: 0,

      pitch_id: '',
      drawerCar: false,
      carList: [],
      total1: 0,
      pageNum1: 1,
      pageSize1: 20,

      is_del: 0,
      is_on_sale: '',
      saleList: [{id:0,name:'未上架'},{id:1,name:'上架'},{id:2,name:'下架'}],
      authList: [{id:0,name:'待审核'},{id:1,name:'已审核'},{id:2,name:'驳回'}],
      activeName: 'first',
      multipleSelection: [],
      shop_id: sessionStorage.getItem('shop_id'),

      searchForm: {
        name: '',
        is_on_sale: '',
        brand_name: '',
        goods_sn: '',
        is_auth: ''
      },

      tableLoadData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    }
  },
  computed: {
    onSaleCount() {
      return this.tableLoadData.filter(i => i.is_on_sale == 1).length
    },
    recommendCount() {
      return this.tableLoadData.filter(i => i.is_recommend == 1).length
    }
  },
  created() {
    this.DataList()
  },
  filters: {
    dateFormat(t) {
      return t ? moment(t*1000).format('YYYY-MM-DD HH:mm') : ''
    },
    isSale(v) {
      return ['未上架','上架','下架'][v] || ''
    },
    isAuth(v) {
      return ['待审核','已审核','驳回'][v] || ''
    }
  },
  methods: {
    headerCellStyle() {
      return { background:'#f5f7fa', fontSize:'12px', fontWeight:500 }
    },
    indexMethod(i) {
      return (this.pageNum-1)*this.pageSize + i + 1
    },

    // ================== 稳定版 Excel 导入 ==================
    async handleRealExcelChange(e) {
  const file = e.target.files[0]
  if (!file) return

  try {
    this.importLoading = true
    this.importProgress = 20
    this.importText = "正在读取Excel..."

    const reader = new FileReader()
    reader.onload = async (event) => {
      try {
        const XLSX = await import('xlsx')
        const workbook = XLSX.read(event.target.result, { type: 'binary' })
        const worksheet = workbook.Sheets[workbook.SheetNames[0]]
        const data = XLSX.utils.sheet_to_json(worksheet)

        if (!data || data.length === 0) {
          this.$message.warning('Excel无数据')
          this.importLoading = false
          return
        }

        this.importProgress = 50
        this.importText = "正在解析数据..."

        const updateList = data.map(item => ({
          goods_name: item['产品名称'] || item['goods_name'] || '',
          shop_price: item['产品价格'] || item['shop_price'] || 0
        })).filter(item => item.goods_name && item.shop_price)

        if (updateList.length === 0) {
          this.$message.warning('未找到有效数据')
          this.importLoading = false
          return
        }

        this.importProgress = 70
        this.importText = "正在批量更新价格..."

        const res = await this.$axios.goodsBatchUpdatePrice( {
          access_token: sessionStorage.getItem('token'),
          company_id: sessionStorage.getItem('company_id'),
          list: updateList
        })

        this.importProgress = 100
        this.successCount = res.data?.success || 0
        this.failCount = res.data?.fail || 0
        this.importText = "更新完成！"

        setTimeout(() => {
          this.importLoading = false
          this.$message.success('批量更新成功')
          this.DataList()
        }, 800)

      } catch (err) {
        console.error(err)
        this.$message.error('解析失败：' + err.message)
        this.importLoading = false
      }
    }
    reader.readAsBinaryString(file)
  } catch (err) {
    this.$message.error('导入失败：' + err.message)
    this.importLoading = false
  }

  // 清空值，允许重复选同一个文件
  e.target.value = ''
},

    // async handleExcelChange(file) {
    //   try {
    //     this.importLoading = true
    //     this.importProgress = 20
    //     this.importText = "正在读取Excel..."

    //     console.log('000000---9999');
        
    //     const reader = new FileReader()
    //     reader.onload = async (e) => {
    //       try {
    //         // 动态加载XLSX，避免报错
    //         const XLSX = await import('xlsx')
    //         const workbook = XLSX.read(e.target.result, { type: 'binary' })
    //         const worksheet = workbook.Sheets[workbook.SheetNames[0]]
    //         const data = XLSX.utils.sheet_to_json(worksheet)

    //         if (!data || data.length === 0) {
    //           this.$message.warning('Excel中无数据')
    //           this.importLoading = false
    //           return
    //         }

    //         this.importProgress = 50
    //         this.importText = "正在解析数据..."

    //         const updateList = data.map(item => ({
    //           goods_name: item['产品名称'] || item['goods_name'] || '',
    //           shop_price: item['产品价格'] || item['shop_price'] || 0
    //         })).filter(item => item.goods_name && item.shop_price)

    //         if (updateList.length === 0) {
    //           this.$message.warning('未找到有效数据')
    //           this.importLoading = false
    //           return
    //         }

    //         // 提交后端
    //         this.importProgress = 70
    //         this.importText = "正在批量更新价格..."
            
    //         const res = await this.$axios.post('/index/goods/batchUpdatePrice', {
    //           access_token: sessionStorage.getItem('token'),
    //           company_id: sessionStorage.getItem('company_id'),
    //           list: updateList
    //         })

    //         this.importProgress = 100
    //         this.successCount = res.data?.success || 0
    //         this.failCount = res.data?.fail || 0
    //         this.importText = "更新完成！"

    //         setTimeout(() => {
    //           this.importLoading = false
    //           this.$message.success('批量更新成功')
    //           this.DataList()
    //         }, 800)

    //       } catch (err) {
    //         console.error(err)
    //         this.$message.error('解析失败：' + err.message)
    //         this.importLoading = false
    //       }
    //     }
    //     reader.readAsBinaryString(file.raw)
    //   } catch (err) {
    //     this.$message.error('导入失败：' + err.message)
    //     this.importLoading = false
    //   }
    // },

    // ================== 原有功能 ==================
    goExcel() {},
    relationCar(row) {
      this.drawerCar = true
      this.pitch_id = row.pitch_id
      this.getCarList()
    },
    getCarList() {
      this.$axios.findCarListP({
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        pageNum: this.pageNum1,
        pageSize: this.pageSize1,
        pitch_id: this.pitch_id
      }).then(res => {
        if (res.code === 200) {
          this.carList = res.data.data
          this.total1 = res.data.total
        }
      })
    },
    handleSizeChange1(v) { this.pageSize1 = v; this.getCarList() },
    handleCurrentChange1(v) { this.pageNum1 = v; this.getCarList() },
    handleSelectionChange(v) { this.multipleSelection = v },
    tabClick() {
      this.is_del = this.activeName === 'fiveth' ? 1 : 0
      const m = {second:0, third:1, fourth:2, first:'', fiveth:''}
      this.is_on_sale = m[this.activeName]
      this.pageNum = 1
      this.DataList()
    },
    handleClick(row) {
      this.$router.push('/simpleGoodsForm?id=' + row.goods_id)
    },
    DataList() {
      this.loading = true
      this.$axios.findByShopGoodsListP({
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        shop_id: this.shop_id,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        is_del: this.is_del,
        is_on_sale: this.is_on_sale,
        keywords: this.searchForm.name
      }).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableLoadData = res.data.data
          this.total = res.data.total
        }
      }).catch(() => this.loading = false)
    },
    handleSizeChange(v) { this.pageSize = v; this.DataList() },
    handleCurrentChange(v) { this.pageNum = v; this.DataList() },
    addData() { this.$router.push('/simpleGoodsForm') },
    searchSubmit() { this.pageNum = 1; this.DataList() },
    changeSale(type) {
      if (!this.multipleSelection.length) return this.$message.warning('请选择商品')
      const ids = this.multipleSelection.map(i => i.goods_id)
      const text = type === 1 ? '上架' : '下架'
      this.$confirm(`确认${text}？`, '提示', { type:'warning' }).then(() => {
        this.$axios.goodsChange({
          operator_id: sessionStorage.getItem('user_id'),
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          goods_ids: ids.join(','),
          is_on_sale: type === 1 ? 1 : 2
        }).then(res => {
          if (res.code === 200) {
            this.$message.success('操作成功')
            this.DataList()
          }
        })
      })
    },
    del(row) {
      this.$confirm('确认删除？', '提示', { type:'warning' }).then(() => {
        this.$axios.delGoods({
          operator_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          goods_id: row.goods_id,
          is_del:1
        }).then(res => {
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.DataList()
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 12px 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
  font-size: 12px;
}
.breadcrumb-wrapper {
  margin-bottom: 12px;
  .el-breadcrumb {
    font-size: 12px;
    i { margin-right: 4px; }
  }
}
.alipay-card {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  ::v-deep .el-card__body { padding: 15px; }
}
.search-bar {
  background: #f8f9fc;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 15px;
  ::v-deep .el-form-item {
    margin-right: 10px;
    margin-bottom: 8px;
  }
  ::v-deep .el-form-item__label {
    font-size: 12px;
    padding-right: 5px;
  }
}
.stat-cards {
  display: flex;
  gap: 15px;
  margin-bottom: 18px;
  flex-wrap: wrap;
  .stat-card {
    flex: 1;
    min-width: 130px;
    background: #fff;
    border-radius: 12px;
    padding: 15px;
    display: flex;
    align-items: center;
    gap: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
    .stat-icon {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 18px;
      &.total { background: linear-gradient(135deg, #1677ff, #4096ff); }
      &.detect { background: linear-gradient(135deg, #00b578, #1acd8c); }
      &.recommend { background: linear-gradient(135deg, #faad14, #ffc53d); }
    }
    .stat-info {
      .stat-value {
        font-size: 22px;
        font-weight: bold;
        color: #333;
      }
      .stat-label {
        font-size: 12px;
        color: #999;
        margin-top: 4px;
      }
    }
  }
}
.btn-group {
  display: flex;
  gap: 8px;
  margin-bottom: 15px;
  flex-wrap: wrap;
}
.table-wrapper {
  margin-bottom: 15px;
}
.el-table {
  font-size: 12px;
  border-radius: 8px;
}
.delete-btn {
  color: #fa6b6b !important;
}
.empty-state {
  text-align: center;
  padding: 40px 0;
  color: #ccc;
  i { font-size: 50px; }
  p { margin-top: 10px; font-size: 12px; }
}
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
}
.alipay-drawer ::v-deep .el-drawer__header {
  padding: 12px 15px;
  background: #f5f7fa;
}
.drawer-content {
  padding: 15px;
}
.upload-excel {
  display: inline-block;
}
</style>